module.exports = __webpack_public_path__ + "static/logo-white-f48b1708cb0d7328bc0bb2e8a0321426.png";